export default __webpack_public_path__ + "static/media/graphic.9b4e2f8e.svg";